import uniqWith from 'lodash/uniqWith'

const BookmarkModel = {
    namespace: 'bookmark',
    state: {
        list: [],
        activeKey: ''
    },
    reducers: {
        push(state, { payload }) {
            const { path, title, routeName } = payload
            const temp = [...state.list]
            for (let index = 0; index < temp.length; index++) {
                const element = temp[index]
                if (element.title === title) {
                    element.path = path
                    element.routeName = routeName
                }
            }
            const list = uniqWith([...state.list, { path, title, routeName }], (a, b) => a.title === b.title)

            return {
                list,
                activeKey: path
            }
        },
        updateActiveKey(state, { payload }) {
            return {
                ...state,
                activeKey: payload
            }
        },
        updateAll(state, { payload }) {
            const { list, activeKey } = payload

            return {
                list,
                activeKey
            }
        }
    }
}

export default BookmarkModel
